module.exports = __webpack_public_path__ + "static/media/img-container_br.4dc20faf.png";